
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { setErrorMessage, setMessage, clearMessage, setHTMLMessage } from "../tools/errorhandling";
import hotelcss from './css/hotelhotellist.module.css';

import {
    myData, updateEmployeedata, uploadEmployeeContract, getserverurl, getallhotels, saveLinkedhotels, getLinkedhotels, savehotelsupervisors,
    getsupervisedhotels
} from "../dbconnector/connector";
import { saveFile } from "../tools/filehandler";
import { useParams } from "react-router-dom";
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import AddDocumentType from '../customNodes/AddDocumentType';

import EmployeeNode from '../customNodes/EmployeeNode';
//AddDocumentType

import { use } from "react";
import moment, { now } from "moment";

const EmplopyeePage = (props) => {
    const t = props.translation
    const [user, setUser] = useState({});
    const [linkedhotels, setLinkedHotels] = useState({});
    const [h24, seth24] = useState([]);
    const [contract, setContract] = useState({});
    const [idcard, setId] = useState([]);
    const [Edit, setEdit] = useState(true);
    const [EditoverHead, setEditOverhead] = useState(true);
    const [hotels, sethotels] = useState([]);
    const [hotelsarray, setHotelArray] = useState([]);
    const [supervisedHotels, setSupervisedHotels] = useState([]);
    const [dragwindow, setDragWindow] = useState(false);
    const [windowtodrag, setWindowtodrag] = useState(null);
    const [left, setleft] = useState(0);
    const [top, settop] = useState(0);


    let { id } = useParams();
    const navigate = useNavigate()


    useEffect(() => {
        LoadUser();
    }, []);

      
    const LoadUser = () => {
        setUser([])
        setEdit(true);
        setEditOverhead(true);
        if (id !== undefined) {
            getsupervisedhotels(id).then(res => {
                if (res.status === 200) {
                    res.json().then(res => {
                        const mappedlist = res.map(item => item.hotel_Id)
                        setSupervisedHotels([...mappedlist])
                    })
                }
                else {
                    setErrorMessage(res.statusText)
                }
            })
            myData(id).then(res => {
                try {
                    setUser({ ...res })
                    setLinkedHotels({})
                    const linkedhotels = getLinkedhotels(res.id)
                    linkedhotels.then(res => {
                        res.json().then(res => {
                            res.forEach(item => {
                                // ////console.log("item", item)
                                ////////console.log("item" , item)
                                if (item["24h"] === 1) {
                                    ////console.log("item", item)
                                    seth24(pre => {
                                        return [
                                            ...pre, item.HOTEL_ID
                                        ]
                                    })
                                } else {
                                    setLinkedHotels(pre => {
                                        return {
                                            ...pre, [item.HOTEL_ID]: { value: true, region: item.from_region === 1 }
                                        }
                                    })
                                }

                            });
                            const hotels = getallhotels(true);
                            hotels.then((hotellist) => {
                                if (hotellist.status === 200) {
                                    //console.log()
                                    sethotels(hotellist.items)
                                } else {
                                    setErrorMessage(t("error_retreivingHotels"))
                                }

                            })

                        })
                    })
                    ////console.log("24h", h24)

                } catch (e) {
                    setErrorMessage(t("error_retreivingData"))
                }
            })
            document.getElementById("editDiv").style.display = "grid";
            document.getElementById("saveDiv").style.display = "none";
        }

    }
    const OnSubmitOverhead = (e) => {
        e.preventDefault()
        const hotelkeys = Object.keys(linkedhotels)
        const tosave = hotelkeys.filter(item => {
            if (!linkedhotels[item].region) {
                return linkedhotels[item]
            }
        })
        let tosaveobject = {};
        hotels.forEach(item => {
            tosaveobject[item.Hotel_ID] = false
        })
        tosave.forEach(item => {
            tosaveobject[item] = true
        })
        const savelinkedhotels = saveLinkedhotels(tosaveobject, user.id, h24)
        savelinkedhotels.then(res => {
            if (res.status === 200) {
                LoadUser()
                setMessage(t("message_dataSaved"))
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    const onSubmit = (e) => {
        if (props.rights === 4) {
            OnSubmitOverhead(e)
        } else {
            e.preventDefault()
            savehotelsupervisors(id, supervisedHotels).then(res => {
                if (res.status === 200) {
                    setMessage(t("message_dataSaved"))
                }
                else {
                    setErrorMessage(res.statusText)
                }
            })

            idcard.forEach((item) => {
                saveFile(item, 1, user.id).then(res => {
                })

            })
            let mandatoryfieldsmissing = ""

            if (user.idnummer === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('ID-nummer') + "</li>"
            }
            if (user.functie === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('functie') + "</li>"
            }
            if (user.ingangsdatum_id === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('ingangsdatum') + "</li>"
            }
            if (user.nr_wkn === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('nr_wkn') + "</li>"
            }
            if (user.voornaam === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('voornaam') + "</li>"
            }
            if (user.geslacht === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('geslacht') + "</li>"
            }
            if (user.contracttype === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('contracttype') + "</li>"
            }
            if (user.contracturen === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('contracturen') + "</li>"
            }
            if (user.contractlooptijd === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('contractlooptijd') + "</li>"
            }
            if (user.FK_Rechten_ID === undefined) {
                mandatoryfieldsmissing = mandatoryfieldsmissing + "<li>" + t('profiel') + "</li>"
            }
            if (mandatoryfieldsmissing !== "") {
                setHTMLMessage(t("fieldsMissing_1") + mandatoryfieldsmissing + t("fieldsMissing_2"))
            } else {
                if (user.contractlooptijd === "1") {
                    user.afloopdatumcontract = null;
                }
                const response = updateEmployeedata({ ...user })
                const hotelkeys = Object.keys(linkedhotels)
                const tosave = hotelkeys.filter(item => {
                    if (!linkedhotels[item].region) {
                        return linkedhotels[item]
                    }
                })
                let tosaveobject = {};
                hotels.forEach(item => {
                    tosaveobject[item.Hotel_ID] = false
                })
                tosave.forEach(item => {
                    tosaveobject[item] = true
                })
                const savelinkedhotels = saveLinkedhotels(tosaveobject, user.id, h24)
                response.then(res => {
                    if (res.status === 200) {
                        res.json().then(body => {
                            if (contract.name) {
                                const contractresponse = uploadEmployeeContract(body[0].id, contract);
                                contractresponse.then(res => {
                                    if (res.status === 200) {
                                        savelinkedhotels.then(res => {
                                            if (res.status === 200) {
                                                LoadUser()
                                                setMessage(t("message_dataSaved"))
                                            } else {
                                                setErrorMessage(res.statusText)
                                            }
                                        })

                                    } else {
                                        setErrorMessage(res.statusText)
                                        savelinkedhotels.then(res => {
                                            if (res.status === 200) {
                                                LoadUser()
                                            } else {
                                                setErrorMessage(res.statusText)
                                            }
                                        })
                                    }
                                })

                            } else {
                                savelinkedhotels.then(res => {
                                    if (res.status === 200) {
                                        LoadUser()
                                    } else {
                                        setErrorMessage(res.statusText)
                                    }
                                })
                            }

                        })
                    } else {
                        setErrorMessage(res.statusText)
                    }
                })

            }
        }
    }

    //setcontracttypevalue
    const setcontracttypevalue = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }

        })
        // let currentmonthNr = new Date().getMonth()
        // let enddate_kwartaal = moment().month(currentmonthNr).endOf('month').format('YYYY-MM-DD')
        // if (currentmonthNr < 3) {
        //     enddate_kwartaal = moment().month(2).endOf('month').format('YYYY-MM-DD')
        // } else if (currentmonthNr > 2 && currentmonthNr < 6) {
        //     enddate_kwartaal = moment().month(5).endOf('month').format('YYYY-MM-DD')
        // } else if (currentmonthNr > 5 && currentmonthNr < 9) {
        //     enddate_kwartaal = moment().month(8).endOf('month').format('YYYY-MM-DD')
        // } else if (currentmonthNr > 8 && currentmonthNr < 12) {
        //     enddate_kwartaal = moment().month(11).endOf('month').format('YYYY-MM-DD')
        // }


        // if (e.target.value === 3 && user.afloopdatumcontract === null && user.in_dienstdatum !== null) {
        //     setUser((prev) => {
        //         return {
        //             ...prev,
        //             "afloopdatumcontract": enddate_kwartaal
        //         }

        //     })
        // }
        // if (e.target.value === 3 && user.afloopdatumcontract === null && user.in_dienstdatum === null) {
        //     setUser((prev) => {
        //         return {
        //             ...prev,
        //             "in_dienstdatum": moment(moment().toDate(), "YYYY-MM-DD")
        //         }

        //     })
        //     setUser((prev) => {
        //         return {
        //             ...prev,
        //             "afloopdatumcontract": enddate_kwartaal
        //         }

        //     })
        // }
        // if (e.target.id === "contracttype_1") {
        //     document.getElementById("ContractualHours").style.display = "none";
        // }
        // if (e.target.id === "contracttype_2") {
        //     document.getElementById("ContractualHours").style.display = "block";
        // }
    }

    const setcontractlooptijdvalue = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
        //InService
        //InServiceLimosa
        if (e.target.value === 1) {
            // delete user.afloopdatumcontract
            document.getElementById("InService").style.display = "none";
        } else {
            document.getElementById("InService").style.display = "block";
        }

        if (e.target.id === "contractlooptijd_2") {
            document.getElementById("OutService").style.display = "block";
        }
        if (e.target.id === "contractlooptijd_3") {
            document.getElementById("OutService").style.display = "block";
        }
        if (e.target.id === "contractlooptijd_1") {
            document.getElementById("OutService").style.display = "none";
        }
    }

    function formatDateToYYYYMMDD(date) {
        if (date !== null) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
            const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
            return `${year}-${month}-${day}`;
        }
        else {
            return null
        }
    }

    const changedate = (e, datefield) => {
        setUser((prev) => {
            return {
                ...prev,
                [datefield]: formatDateToYYYYMMDD(e)
            }
        })
    }

    const setdecimal = (e) => {
        // //////console.log(e.target.type)

        // setUser((prev) => {
        //     return {
        //         ...prev,
        //         [e.target.name]: e.target.value
        //     }

        // })

    }


    const changevalue = (e) => {
        //console.log("[", e.target.name,"]:", e.target.checked)
        setUser((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }

        })

    }

    const changecheckbox = (e) => {

        setUser((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.checked
            }

        })

    }

    const changehotelcheckbox = (e) => {
        ////console.log(Number(e.target.name), e.target.checked)

        if (e.target.checked) {
            setLinkedHotels((prev) => {
                return {
                    ...prev,
                    [e.target.name]: e.target.checked
                }
            })
        } else {
            setLinkedHotels((prev) => {
                return {
                    ...prev,
                    [e.target.name]: false
                }
            })
        }
        // setLinkedHotels((prev) => {
        //     return {
        //         ...prev,
        //         [e.target.name]: e.target.checked
        //     }
        // })
    }

    // const DeactivateUser = () => {
    //     //////////console.log(user.actief)
    //     //////////console.log(document.getElementById("userActive").checked ? false : true)
    //     document.getElementById("userActive").checked = document.getElementById("userActive").checked ? false : true;
    // }

    const openContract = () => {
        window.open(getserverurl() + user.contract, "_blank")
    }

    const navigateback = () => {
        navigate('/employees')
    }

    const handleEdit = () => {
        if (props.rights === 2) {
            setEdit(false)
            setEditOverhead(false)
            buildhotelsArray(hotels, false, false)

        } else if (props.rights === 4) {
            setEditOverhead(false)
            buildhotelsArray(hotels, true, false)
        }
        document.getElementById("editDiv").style.display = "none";
        document.getElementById("saveDiv").style.display = "grid";
    }

    const handleCancel = () => {
        document.getElementById("coverAll").style.display= 'none'
        LoadUser()
    }

    useEffect(() => {
        buildhotelsArray(hotels, Edit, EditoverHead)
    }, [hotels]);


    useEffect(() => {
        if (hotels.length > 0) {
            setHotelArray([]);
            hotels.forEach((item, index) => {
                setHotelArray(pre => [...pre,
                <div id={item.Hotel_ID} className={index % 2 === 0 ? hotelcss.hotellinkVarient1 : hotelcss.hotellinkVarient2} >
                    <p>{item.nr_afd}</p>
                    <p>{item.Name}</p>
                    <input id={item.Hotel_ID} type='CheckBox' className="checkbox" name={item.Hotel_ID} checked={linkedhotels[item.Hotel_ID] ? linkedhotels[item.Hotel_ID].value : false} onChange={changehotelcheckbox} disabled={linkedhotels[item.Hotel_ID] ? linkedhotels[item.Hotel_ID].region ? true : Edit : Edit}></input>
                    <input id={"supervisor" + item.Hotel_ID} type='CheckBox' className="checkbox" name={item.Hotel_ID} checked={supervisedHotels.includes(item.Hotel_ID) ? true : false} onChange={savesupervisor} disabled={Edit}></input>
                    <input id={"24H" + item.Hotel_ID} type='CheckBox' className="checkbox" name={item.Hotel_ID} checked={h24.includes(item.Hotel_ID) ? true : false} onChange={save24H} disabled={linkedhotels[item.Hotel_ID]? true : EditoverHead}></input>
                </div>
                ])
            })
        }

    }, [linkedhotels, supervisedHotels, h24]);

    const savesupervisor = (e) => {
        if (e.target.checked) {
            setSupervisedHotels(pre => {
                return [...pre, Number(e.target.name)]
            })
        } else {
            setSupervisedHotels(pre => {
                return pre.filter(item => item !== Number(e.target.name))
            })
        }
    }

    const save24H = (e) => {
        if (e.target.checked) {
            ////console.log(Number(e.target.name), e.target.checked)
            seth24(pre => {
                return [...pre, Number(e.target.name)]
            })
        } else {
            seth24(pre => {
                return pre.filter(item => item !== Number(e.target.name))
            })
        }
    }
    const buildhotelsArray = (hotels, active, activeoverhead) => {
        ////console.log("buildhotelsArray", h24)
        if (hotels.length > 0) {
            setHotelArray([]);
            hotels.forEach((item, index) => {
                setHotelArray(pre => [...pre,
                <div id={item.Hotel_ID} className={index % 2 === 0 ? hotelcss.hotellinkVarient1 : hotelcss.hotellinkVarient2} >
                    <p>{item.nr_afd}</p>
                    <p>{item.Name}</p>
                    <input id={item.Hotel_ID} type='CheckBox' className="checkbox" name={item.Hotel_ID} checked={linkedhotels[item.Hotel_ID] ? linkedhotels[item.Hotel_ID].value : false} onChange={changehotelcheckbox} disabled={linkedhotels[item.Hotel_ID] ? linkedhotels[item.Hotel_ID].region ? true : active : active}></input>
                    <input id={"supervisor" + item.Hotel_ID} type='CheckBox' className="checkbox" name={item.Hotel_ID} checked={supervisedHotels.includes(item.Hotel_ID) ? true : false} onChange={savesupervisor} disabled={active}></input>
                    <input id={"24H" + item.Hotel_ID} type='CheckBox' className="checkbox" name={item.Hotel_ID} checked={h24.includes(item.Hotel_ID) ? true : false} onChange={save24H} disabled={linkedhotels[item.Hotel_ID]? true : activeoverhead}></input>
                    
                </div>
                ])
            })
        }
    }

    const startdrag = (windowname, drag, e) => {
        //"assignmentDetailsNode"
        //assignmentdetails
        //assignmentIssuedetails
        //dagstaatpermedewerker
        setWindowtodrag(windowname)
        if (e !== null) {
            var rect = e.target.getBoundingClientRect();
            setleft(e.clientX - rect.left)
            settop(e.clientY - rect.top)
            setDragWindow(drag)
            if (drag === true && windowname !== null) {
                resetzindexes(windowname)
            }
        }

    }

    const MouseMove = (e) => {
        if (dragwindow === true && windowtodrag !== null) {
            document.getElementById(windowtodrag).style.top = (e.clientY - (10 - window.pageYOffset)) + "px"
            document.getElementById(windowtodrag).style.left = (e.clientX - (left - window.pageXOffset)) + "px"
        }
    }
    const resetzindexes = (windowname) => {
        document.getElementById(windowname).style.zIndex = 2
    }

    return (
        <>
            <div id="main" className="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <br></br>
                            <center> <Button type="button" id="CloseMessageButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button> &nbsp;
                            </center>
                        </div>
                    </div>
                    <div className="checkinTime"><div id="timelabel" ></div><div id="time"></div></div></header>
                <div id="return" className="form">
                    <Button type="button" id="cancelButton" class="Savebutton btn btn-primary margin-right" onClick={navigateback} >{t('Naaroverzicht')}</Button>
                </div>
                <EmployeeNode
                    rights={props.rights}
                    translation={props.translation}
                    isDisabled={Edit}
                    hotelsarray={hotelsarray}
                    data={{ user: user }}
                    events={{startdrag: startdrag, handleCancel: handleCancel, MouseMove:MouseMove, changedate: changedate, changecheckbox: changecheckbox, changevalue: changevalue, handleEdit: handleEdit, handleCancel: handleCancel, setId: setId, setContract: setContract, openContract: openContract, setcontractlooptijdvalue: setcontractlooptijdvalue, setcontracttypevalue: setcontracttypevalue, navigateback: navigateback, onSubmit: onSubmit, startdrag:startdrag }}
                    displaytabs={{ tab1: true, tab2: true, tab3: true, tab4: true, tab5: true, tab6: true, tab7: true }}
                    disabledtabs={{ tab1: false, tab2: false, tab3: false, tab4: false, tab5: false, tab6: false, tab7: false }}
                    defaulttab="0"
                />
            </div>
                {/* <div id="coverAll" className="subscreen" onMouseMove={MouseMove}>
                 <AddDocumentType  rights={props.rights} t={props.translation} events={{startdrag: startdrag, handleCancel: handleCancel}}></AddDocumentType>
            </div> */}
        </>
    )
}
export default EmplopyeePage